import { createSlice } from "@reduxjs/toolkit";
import { getPharmacySalesSummary } from "../../reducer/pharmacySalesSummary/pharmacySalesSummaryReducer";

import i18n from "../../i18n";
const initialState = { data: null, isLoading: false, error: null };

const pharmacySalesSummarySlice = createSlice({
  name: "pharmacySalesSummary",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPharmacySalesSummary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPharmacySalesSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || null;
      })
      .addCase(getPharmacySalesSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("pharmacy.toast.failedToLoadSalesSummary");
      });
  },
});

export default pharmacySalesSummarySlice.reducer;
